// extracted by mini-css-extract-plugin
export var orderDetails = "_sa-2";
export var orderImage = "_sa-1";
export var orderMeta = "_sa-3";
export var orderSummary = "_sa-0";
export var rightArrow = "_sa-4";